module.exports = __webpack_public_path__ + "static/media/arrow-right.c29b6ea6.svg";